import React, { Component } from 'react';
import Damdfe from './Damdfe';
import { withRouter, Link } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import buscarDamdfe from '../../actions/mdfe/buscarDamdfe';
import { connect } from 'react-redux';
import qs from 'qs';
import { PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';

class PainelDamdfe extends Component {

    constructor(props) {
        super(props);
        this.state = {
            referenciaSelecionada: null
        }
    }

    componentDidMount() {
        const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
        if (parametros.mdfe && this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.setState({ referenciaSelecionada: React.createRef() });
            this.props.buscarDamdfe(parametros.mdfe, this.props.empresaSelecionada.id);
            document.body.classList.add('impressao-damdfe');
        } else {
            this.props.history.push('/painel-mdfe');
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('impressao-damdfe');
    }

    exibirBotoes() {
        return (
            <React.Fragment>
                <Link className="mt-4 ml-2 mr-4" to="/painel-mdfe">
                    <button className='btn btn-laranja'>Concluir</button>
                </Link>
                <ReactToPrint
                    pageStyle="@page { size: A4; margin: 10mm; } html, body { width: 100%; height: auto; margin: 0; padding: 0; background: #fff; box-sizing: border-box; }"
                    trigger={() => (
                        <button disabled={!this.state.referenciaSelecionada} className="btn btn-laranja">
                            IMPRIMIR
                        </button>
                    )}
                    content={() => document.querySelector('#damdfe')}
                    documentTitle="damdfe"
                />
            </React.Fragment>
        )
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id)]}>
                {this.exibirBotoes()}
                <Damdfe ref={this.state.referenciaSelecionada} />
                {this.exibirBotoes()}
            </Autorizacao>
        )
    }
}

export const mapStateToProps = state => ({
    empresaSelecionada: state.empresaSelecionada,
});

export default withRouter(connect(mapStateToProps, { buscarDamdfe })(PainelDamdfe));
